import * as React from 'react';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import {Section} from 'components/UIKit';
import * as locales from './locales';
import {SimilarListing} from './components';
import styles from './SimilarListings.scss';

export interface SimilarListingsProps {
  similar: any[];
  reference: any;
}

export interface SimilarListingsState {
  selected: string;
}

class SimilarListingsComponent extends React.Component<
  SimilarListingsProps & WithI18nProps,
  SimilarListingsState
> {
  state: SimilarListingsState = {
    selected: '',
  };

  handleCompare = (listing) => {
    this.setState((prevState) => ({
      selected: prevState.selected === listing.id ? '' : listing.id,
    }));
  };

  render() {
    const {similar, reference, i18n} = this.props;
    const {selected} = this.state;

    return (
      <Section
        heading={i18n.translate('similarBusinesses')}
        headingProps={{type: 'h5', component: 'h2'}}
        spacing="small"
        fullWidth
      >
        <ul className={styles.List}>
          {similar.map((listing, i) => (
            <SimilarListing
              key={listing.id}
              last={i === similar.length - 1}
              listing={listing}
              reference={reference}
              onCompareClick={this.handleCompare}
              showComparison={listing.id === selected}
            />
          ))}
        </ul>
      </Section>
    );
  }
}

export const SimilarListings = withI18n({
  id: 'SimilarListings',
  fallback: locales.en,
})(SimilarListingsComponent);

export default SimilarListings;
